import React, { FC } from 'react';

import { get } from 'lodash';
import BescheidDownload from '../../../../../../../components/ui-component/form-component/bescheid-download/BescheidDownload';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { APIS } from '../../../../../../../lib/constants/apis';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const AblehnungsbescheidAntragGlobal: FC<{}> = () => {
	const { application } = useApplication();

	const bescheidPath = P.Foerderbescheid_Foerderbescheid.path;
	const bescheidDownloadOnPath = P.Freigabe_Uebermittlung_Heruntergeladen_Am.path;
	const bescheidDownloadStrapiFieldName = 'Freigabe_Uebermittlung_Heruntergeladen_Am';
	const apiName = APIS.Antrag;
	const apiObjectId = get(application, 'id');

	return (
		<>
			<ApplicationHeading title="Ablehnungsbescheid" description={PLATZHALTER_TEXT} />
			<BescheidDownload
				bescheidPath={bescheidPath}
				bescheidDownloadOnPath={bescheidDownloadOnPath}
				bescheidDownloadStrapiFieldName={bescheidDownloadStrapiFieldName}
				apiName={apiName}
				apiObjectId={apiObjectId}
			/>
		</>
	);
};
export default AblehnungsbescheidAntragGlobal;
